export const findRefOffsetToParent = (
  ref,
  parentRef,
  offsetProp = 'offsetLeft'
) => {
  const findOffset = (currentRef, offset = 0) => {
    const { offsetParent } = currentRef
    if (!offsetParent) return offset
    const currentOffset = currentRef[offsetProp]
    const newOffset = currentOffset + offset

    if (offsetParent === parentRef.current) {
      return newOffset
    }

    return findOffset(offsetParent, newOffset)
  }

  return findOffset(ref.current)
}
